<template>
  <div class="fullheight">
    <el-form v-form data-vv-scope="tenantMailServerForm">
      <eco-form-item label="邮箱地址" label-width="180px">
        <eco-input v-model="tenantMailServer.userName" validate="required" />
      </eco-form-item>
        <eco-form-item label="邮件类型" label-width="180px">
          <eco-select
            v-model="tenantMailServer.mailType"
            :options="[{'key': 'pop3', 'value':'pop3类型'},{'key': 'imap', 'value':'imap类型'}]"
            :validate="{'required':true}"
            @change="mailTypeChange"
          />
        </eco-form-item>
        <eco-form-item label="协议服务器" label-width="180px">
          <eco-input v-model="tenantMailServer.mailHost" autocomplete="off" validate="required" />
        </eco-form-item>
        <eco-form-item label="密码" label-width="180px">
          <eco-input v-model="tenantMailServer.mailPass" show-password autocomplete="off" validate="required" />
        </eco-form-item>
        <eco-form-item label="昵称" label-width="180px">
          <eco-input v-model="tenantMailServer.nickName" validate="required" />
        </eco-form-item>
        <eco-form-item label="端口号" label-width="180px">
          <eco-input v-model="tenantMailServer.mailPort" validate="required" />
        </eco-form-item>
        <eco-form-item label="是否使用SSL认证" label-width="180px">
          <eco-select
            v-model="tenantMailServer.useSsl"
            :options="[{'key': 0, 'value':'否'},{'key': 1, 'value':'是'}]"
            :validate="{'required':true}"
          />
        </eco-form-item>
        <eco-form-item label="说明" label-width="180px">
          <eco-input type="textarea" v-model="tenantMailServer.desc" placeholder="请输入邮件服务器说明" />
        </eco-form-item>
      </el-form>
      <div v-show="false" slot="footer" style="text-align: center">
        <fe-submit-button
          url="${uc}/uc/tenantMailServer/v1/save"
          ref="tenantMailSaveBtn"
          :model="tenantMailServer"
          scope-name="tenantMailServerForm"
        >{{$t("eip.common.save")}}</fe-submit-button>
      </div>
  </div>
</template>
<script>

export default {
   name: "tenantMailSereverManager",
   props: {
    tenantId: String
  },
  data() {
    return {
      dialogVisible: false,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      tenantMailServer: {}
    };
  },
  mounted() {
    this.$validator = this.$root.$validator;
    let url = "${uc}/uc/tenantMailServer/v1/getByCurrent";
    if(this.tenantId){
        url += "?tenantId="+this.tenantId;
    }
    this.$http.get(url).then(resp => {
        this.tenantMailServer = resp.data;
    }, error => {
        reject(error);
    })
  },
  methods: {
    saveData(){
      this.$refs.tenantMailSaveBtn.$el.click();
    },
    mailTypeChange(change){
      if (this.tenantMailServer.userName){
        let address = this.tenantMailServer.userName;
        let s = address.substring(address.indexOf('@') + 1,
          address.length + 1).trim();
        if (change == 'pop3') {
          this.tenantMailServer.mailHost = 'pop.' + s;
        }
        if (change == 'pop3') {
          if (!(s == 'gmail.com' || s == 'msn.com' || s == 'live.cn' || s == 'live.com' || s == 'hotmail.com')) {
            this.tenantMailServer.mailPort = '110';
          }
        } else if (change == 'imap') {
          if (!(s == 'gmail.com' || s == 'msn.com' || s == 'live.cn' || s == 'live.com' || s == 'hotmail.com')) {
            this.tenantMailServer.mailPort = '143';
          }
          this.tenantMailServer.mailHost = 'imap' + '.' + s;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sp-manager__dialog /deep/ > .el-dialog > .el-dialog__body {
  height: calc(100% - 170px);
}
</style>
